import React, { useState } from "react";
import Chart from "react-apexcharts";

const AreaChartPreview = (props) => {
    const { fontFamily, height, series, values, seriesName } = props;

    // Procesar los strings en arrays
    const categories = series.split(","); // Convierte la string en un array
    const seriesData = values.split(",").map((value) => parseFloat(value)); // Convierte los valores a números

    const [chartData] = useState({
        series: [
            {
                name: seriesName, // Agregar el nombre de la serie
                data: seriesData,
            },
        ],
        options: {
            chart: {
                type: "area",
                height: "100%",
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false, // Desactiva las etiquetas de datos
            },
            stroke: {
                curve: "smooth", // Línea suavizada
                width: 2,
                colors: [props.color],
            },
            xaxis: {
                categories, // Nombres de los meses
                labels: {
                    style: {
                        fontFamily,
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        fontFamily,
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => `${val.toLocaleString("es-ES")}`, // Corrección en el uso de la sintaxis de template string
                },
            },
            markers: {
                size: 4, // Tamaño de los puntos en el gráfico
                colors: [props.colorSecondary], // Color de los puntos
                hover: {
                    size: 6, // Tamaño de los puntos cuando pasas el ratón
                    colors: [props.colorSecondary], // Color de los puntos cuando pasas el ratón
                },
            },
            fill: {
                type: "gradient",
                gradient: {
                    shadeIntensity: 1,
                    gradientToColors: ["#" + props.colorSecondary.replace("#", "")], // Segundo color del gradiente
                    type: "vertical", // Dirección del gradiente
                    opacityFrom: 0.7,
                    opacityTo: 0.3,
                    stops: [0, 100], // Gradiente de 0% a 100%
                    colorStops: [
                        { offset: 0, color: "#" + props.color.replace("#", ""), opacity: 1 }, // Color principal en el inicio
                        { offset: 100, color: "#" + props.colorSecondary.replace("#", ""), opacity: 1 }, // Color secundario al final
                    ],
                },
            },
            grid: {
                borderColor: "#e7e7e7",
            },
            title: {
                align: "center",
                style: {
                    fontSize: "20px",
                    fontFamily,
                },
            },
        },
    });

    return (
        <div style={{ height, display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
                <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="area"
                    height={height}
                    width="100%"
                />
            </div>
        </div>
    );
};

export default AreaChartPreview;
